// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"388c7980","237":"2fff4a39","486":"a9431193","512":"81f42f39"}[chunkId] + ".chunk.js";
};